// src/pages/ContactUsPage.jsx
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ModalForm from "./Modal";
import axios from "axios";

const Profile = () => {
    const [user,setUser] = useState(null);
    const [showModal, setShowModal] = useState(false);
    console.log(user)
//   const user = {
//     name: "Divyanshu Shekhar",
//     email: "divyanshu@example.com",
//     gender: "Male",
//     phone: "9876543210",
//     address: "Delhi, India",
//     bio: "Full Stack Developer with a love for learning and problem-solving.",
//   };
  useEffect(() => {
  const fetchData = async () => {
    let baseUrl = "";
    if (process.env.NODE_ENV === "production") {
      baseUrl = "https://imw-edu.com/edubackend";
    } else {
      baseUrl = "http://localhost/edubackend";
    }
    const url = `${baseUrl}/getuserdetail.php`;
    try {
      const res = await axios.get(url, { withCredentials: true });
      setUser(res.data);
    } catch (err) {
      console.error("Failed to fetch user data", err);
    }
  };

  fetchData();
}, [showModal]);

  

  const editprofile = (showModal) => {
    setShowModal(showModal); // Toggle the modal
  };
  return (
    <>
      {/* Page Title Section */}
      <div className="wd-page-title page-title page-title-default title-size-default title-design-centered color-scheme-light">
        <div className="container">
          <h1 className="entry-title title">Profile</h1>
          <nav className="wd-breadcrumbs">
            <span typeof="v:Breadcrumb">
              <Link to="/" rel="v:url" property="v:title">
                Home
              </Link>
            </span>
            <span className="wd-delimiter"></span>
            <span className="wd-last">Contact us</span>
          </nav>
        </div>
      </div>

      {/* Main Content Area for Contact Us */}
      <div className="wd-page-content main-page-wrapper">
        <main
          className="wd-content-layout content-layout-wrapper container"
          role="main"
        >
          <div className="wd-content-area site-content">
            <article
              id="post-211"
              className="entry-content post-211 page type-page status-publish hentry"
            >
              <div
                data-elementor-type="wp-page"
                data-elementor-id="211"
                className="elementor elementor-211"
              >
                {/* Profile Section */}
                <section
                  className="wd-negative-gap elementor-section elementor-top-section elementor-element elementor-element-1ebcc4d7 wd-section-stretch-content elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="1ebcc4d7"
                  data-element_type="section"
                >
                  <div className="elementor-container elementor-column-gap-no">
                    <div
                      className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-45af4094"
                      data-id="45af4094"
                      data-element_type="column"
                    >
                      <div className="elementor-widget-wrap elementor-element-populated" style={{display:"flex",justifyContent:"center"}}>
                        <div
                        >
                          <div className="elementor-widget-container">
                            <div className="elementor-custom-embed">
                              <div className="container mt-5">
                                 {showModal  ? <ModalForm userdata={user} editprofile={editprofile} onClose={() => setShowModal(false)} /> : <div
                                  className="card shadow-lg p-4 rounded-4"
                                  style={{ maxWidth: "800px", margin: "auto" }}
                                >
                                  <div className="row g-4 align-items-center">
                                    <div className="col-md-4 text-center">
                                      <img
                                        src="https://plus.unsplash.com/premium_photo-1664474619075-644dd191935f?fm=jpg&q=60&w=3000&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8aW1hZ2V8ZW58MHx8MHx8fDA%3D"
                                        alt="Profile"
                                        className="img-fluid rounded-circle border border-4 border-primary"
                                        style={{
                                          width: "180px",
                                          height: "180px",
                                          objectFit: "cover",
                                        }}
                                      />
                                    </div>
                                    <div className="col-md-8">
                                      <h3 className="fw-bold">{user?.name}</h3>
                                      <p className="text-muted mb-1">
                                        {user?.email}
                                      </p>
                                      <p className="text-muted mb-1">
                                        Gender: {user?.gender}
                                      </p>
                                     
                                      <p>
                                        <strong>Phone:</strong> {user?.mobilenumber}
                                      </p>
                                      <p>
                                        <strong>Address:</strong> {user?.address}
                                      </p>
                                      <p>
                                        {/* <strong>Bio:</strong> {user?.bio} */}
                                      </p>
                                      <button onClick={editprofile}>Edit Profiile</button>
                                    </div>
                                  </div>
                                </div>}
                                
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </article>
          </div>
        </main>
      </div>
    </>
  );
};

export default Profile;
